 <template>
  <div>
    <a class="resend-method" @click="() => resendUsingConfirmationType('SMS')">
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" rx="24" fill="#D7F0F6" />
        <path
          d="M19.5 20.25H28.5M19.5 23.25H24M14.25 24.7593C14.25 26.3604 15.3734 27.754
          16.9575 27.987C18.086 28.1529 19.2272 28.2796 20.3799 28.3655C20.73 28.3916
          21.0502 28.5753 21.245 28.8674L24 33L26.755 28.8675C26.9498 28.5753 27.2699
          28.3917 27.6201 28.3656C28.7727 28.2796 29.914 28.153 31.0425 27.9871C32.6266
          27.7542 33.75 26.3606 33.75 24.7595V18.7406C33.75 17.1395 32.6266 15.7458 31.0425
           15.5129C28.744 15.175 26.3926 15 24.0003 15C21.6078 15 19.2561 15.175 16.9575
            15.513C15.3734 15.7459 14.25 17.1396 14.25 18.7406V24.7593Z"
          stroke="#36A3CA"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div class="content">
        <p class="title">Receber por SMS</p>
        <p class="subtitle">
          {{ phone | phoneMask({ lastDigits: true }) }}
        </p>
      </div>
      <ChevronRightIcon class="arrow" />
    </a>

    <a
      class="resend-method last"
      @click="() => resendUsingConfirmationType('WHATSAPP')"
    >
      <svg
        style="border-radius: 999999px;"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" rx="24" fill="#D7F0F6" />
        <g
          transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
          fill="#13aefb"
          stroke="none"
        >
          <path style="transform: scale(0.5);" fill="#36A3CA"
            d="M405 685 c-22 -8 -59 -34 -82 -58 -59 -62 -76 -136 -52 -218 9 -29 9
-52 0 -95 -6 -32 -9 -59 -7 -61 2 -2 30 3 62 11 43 11 62 12 78 4 30 -16 125
-14 166 4 45 19 99 73 118 118 8 19 15 60 15 90 0 153 -150 257 -298 205z
m161 -34 c50 -23 88 -71 104 -129 37 -142 -101 -272 -243 -228 -34 10 -57 12
-80 5 -17 -5 -35 -9 -38 -9 -4 0 -7 26 -6 58 0 31 -3 78 -8 103 -24 148 132
263 271 200z"
          />
          <path style="transform: scale(0.5);" fill="#36A3CA"
            d="M379 556 c-7 -14 -9 -35 -5 -49 14 -57 108 -137 161 -137 31 0 65 25
65 47 0 18 -56 26 -79 11 -18 -11 -24 -9 -56 22 -29 28 -34 40 -30 62 13 56
-34 92 -56 44z"
          />
        </g>
      </svg>
      <div class="content">
        <p class="title">Receber por Whatsapp</p>
        <p class="subtitle">
          {{ phone | phoneMask({ lastDigits: true }) }}
        </p>
      </div>
      <ChevronRightIcon class="arrow" />
    </a>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { ChevronRightIcon } from '@vue-hero-icons/solid';
import StringMixing from '@/mixins/string';
import UtilMixin from '@/mixins/util';

export default {
  name: 'resend-confirmation-options',
  mixins: [StringMixing, UtilMixin],
  components: {
    ChevronRightIcon,
  },
  computed: {
    ...mapGetters('minifiedOnboarding', [
      'phone',
      'type',
      'disableTheResendCounter',
    ]),
  },
  methods: {
    ...mapActions('minifiedOnboarding', [
      'resendConfirmation',
      'resendCodeAndRedirect',
      'resendCodeAndRedirect',
      'setShowResendOptions',
    ]),
    ...mapMutations('minifiedOnboarding', [
      'setChosenConfirmationResendType',
      'setResendConfirmationType',
    ]),
    resendUsingConfirmationType(resendType) {
      this.setResendConfirmationType(resendType);
      this.setChosenConfirmationResendType();
      this.resendConfirmation();
      this.setShowResendOptions({ showResendOptions: false });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/__new-styles.scss";

.resend-method-title {
  font-family: "Usual";
  font-size: 20px;
  line-height: 28px;
  color: var(--gray-900);
  padding: 20px 0;
}

.resend-method {
  display: flex;
  gap: 12px;
  padding: 16px 0 16px 0;
  cursor: pointer;

  &.last {
    border-top: 1px solid var(--gray-200);
  }
}

.resend-method .icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  background-color: var(--gray-200);
  color: var(--gray-500);
  border-radius: 50%;
}

.resend-method .content {
  flex: 1;
}

.resend-method .title {
  @extend .body-semi-bold;
  color: var(--gray-900);
  font-size: 16px;
  line-height: 24px;
}

.resend-method .subtitle {
  @extend .small-regular;
  color: var(--gray-500);
  font-size: 14px;
  line-height: 24px;
}

.resend-method .arrow {
  align-self: center;
  color: var(--gray-900);
}

.resend-code {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #36a3ca;
  margin-top: 24px;
  margin-bottom: 36px;
}

.option-title > img,
> svg {
  margin: unset;
}

@media (min-width: $lg) {
  .resend-method-wrapper {
    padding: 0px;
  }

  .resend-method-title {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 36px;
  }

  .resend-method {
    border: 1px solid var(--gray-200);
    border-radius: 8px;
    padding: 16px;

    &.last {
      margin-top: 12px;
    }
  }
}
</style>
